import React from 'react';
import ReactDOM from 'react-dom';
import { ThemeProvider } from '@emotion/react';
import { UIKitProvider } from '@ui-kit-ngs/providers';
import { getTheme } from '@ui-kit-ngs/theme';
import deviceDetector from '../components/DeviceDetector';
import Translator from '../components/Translator';
import PageCommon from '../pages/PageCommon';

const getLocale = () => Translator.getLocale() || 'en-gb';
const getDevice = () => deviceDetector.getDeviceType();
const deviceDetectorInstance = deviceDetector.getApi();
const getPlatform = () => deviceDetectorInstance.getPlatform();
const getJurisdiction = () => deviceDetectorInstance.getJurisdiction();
const getEnvironment = () => deviceDetectorInstance.getEnvironment();

const navigate = (path, { trigger, ignoreBackButton, replace }) => {
    if(path.startsWith('#')) {
        window.location.hash = path;
    } else {
        PageCommon.navigate(path, trigger, ignoreBackButton, replace);
    }
};

const withUIKit = (component, device, locale)  => {
    const theme = getTheme({ device });
    const themeProvider = React.createElement(ThemeProvider, { theme }, component);
    return React.createElement(UIKitProvider, { locale }, themeProvider);
};

// const withTranslations = (component, translations) => {
//     return React.createElement(TranslatorProvider, { translations }, component);
// };

export function render(container, { uiKit /*, translations */ }, createComponent) {
    const device = getDevice();
    const locale = getLocale();
    const platform = getPlatform();
    const jurisdiction = getJurisdiction();
    const environment = getEnvironment();

    let component = createComponent({ device, navigate, locale, platform, jurisdiction, environment });

    if (uiKit) {
        component = withUIKit(component, device, locale);
    }

    // if (translations) {
    //     component = withTranslations(component, translations);
    // }

    ReactDOM.render(component, container);
}
